import {StyleSheet, Text, View} from "react-native";
import {Href, Link} from "expo-router";
import PrimaryText from "@/lib/components/PrimaryText";

type Props = {
    text: string,
}

class Word {
    text: string;

    constructor(text: string) {
        this.text = text;
    }
}

class Url {
    url: string;
    text: string;

    constructor(text: string) {
        function trimUrl(url: string): string {
            return url.replace(/[.,!?;:)\]}]+$/g, "");
        }

        this.text = text;
        this.url = trimUrl(text);
    }
}

export default function MagicText({text}: Props) {
    const lines = text.split(/\n/);

    const makeSegments = (text: string) => {
        let elements = [];
        let buffer = "";
        const words = text.split(/\s/);
        for (let i = 0; i < words.length; i++) {
            if (words[i].startsWith("https://")) {
                elements.push(new Word(buffer.trim()));
                elements.push(new Url(words[i]));
                buffer = "";
            } else {
                buffer = buffer + words[i] + ' ';
            }
        }
        elements.push(new Word(buffer.trim()));
        return elements;
    }

    const makeLine = (line: string) => {
        const segments = makeSegments(line);
        let result = [];
        for (let i = 0; i < segments.length; i++) {
            if (segments[i] instanceof Url) {
                const segment = segments[i] as Url;
                result.push(<Link key={i} href={segment.url as Href} style={styles.link}>{segment.text}</Link>)
            } else if (segments[i] instanceof Word) {
                const segment = segments[i] as Word;
                if (segment.text.length === 0) {
                    continue;
                }
                result.push(<PrimaryText key={i}>{segment.text}</PrimaryText>)
            }
        }
        return result;
    }

    const allLines = lines.map(makeLine);

    return (
        <View style={styles.outer}>
            {allLines.map((line, id) =>
                <Text key={id} style={styles.line}>
                    {line.map(element => element)}
                </Text>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    outer: {
        flexDirection: "column",
        gap: 6,
    },
    line: {},
    link: {
        textDecorationLine: "underline",
        marginHorizontal: 4,
    }
});